// All copy is server-rendered. Enhance the anchor links into desktop tabs or
// an illustrated mobile accordion, moving the same panels rather than copying them.
document.querySelectorAll("[data-rov-system]").forEach((root) => {
    const tabList = root.querySelector("[data-rov-system-tabs]");
    const details = root.querySelector(".rov-system__details");
    const tabs = [...tabList.querySelectorAll("[data-rov-system-part]")];
    const panels = [...details.querySelectorAll("[data-rov-system-panel]")];
    const mobile = window.matchMedia("(max-width: 767px)");
    let activeId = mobile.matches ? null : "rov";

    function selectPart(id, focus = false) {
        activeId = id;
        tabs.forEach((tab) => {
            const selected = tab.dataset.rovSystemPart === id;
            tab.setAttribute(mobile.matches ? "aria-expanded" : "aria-selected", String(selected));
            tab.tabIndex = mobile.matches || selected ? 0 : -1;
            if (selected && focus) {
                tab.focus();
            }
        });
        panels.forEach((panel) => {
            panel.hidden = panel.dataset.rovSystemPanel !== id;
        });
    }

    function configureLayout() {
        if (mobile.matches) {
            tabList.removeAttribute("role");
        } else {
            tabList.setAttribute("role", "tablist");
        }

        tabs.forEach((tab, index) => {
            const panel = panels[index];
            tab.setAttribute("role", mobile.matches ? "button" : "tab");
            tab.removeAttribute(mobile.matches ? "aria-selected" : "aria-expanded");
            tab.setAttribute("aria-controls", panel.id);
            panel.setAttribute("role", mobile.matches ? "region" : "tabpanel");
            panel.setAttribute("aria-labelledby", tab.id);
            panel.tabIndex = mobile.matches ? -1 : 0;
            if (mobile.matches) {
                tab.after(panel);
            } else {
                details.append(panel);
            }
        });

        // A mobile accordion may be fully collapsed; desktop tabs always select one.
        selectPart(activeId || (mobile.matches ? null : "rov"));
    }

    tabs.forEach((tab, index) => {
        function activate() {
            const id = tab.dataset.rovSystemPart;
            selectPart(mobile.matches && activeId === id ? null : id);
        }

        tab.addEventListener("click", (event) => {
            event.preventDefault();
            activate();
        });
        tab.addEventListener("keydown", (event) => {
            if (event.key === " ") {
                event.preventDefault();
                activate();
                return;
            }

            let next;
            if (event.key === (mobile.matches ? "ArrowDown" : "ArrowRight")) {
                next = (index + 1) % tabs.length;
            } else if (event.key === (mobile.matches ? "ArrowUp" : "ArrowLeft")) {
                next = (index - 1 + tabs.length) % tabs.length;
            } else if (event.key === "Home") {
                next = 0;
            } else if (event.key === "End") {
                next = tabs.length - 1;
            } else {
                return;
            }

            event.preventDefault();
            if (mobile.matches) {
                tabs[next].focus();
            } else {
                selectPart(tabs[next].dataset.rovSystemPart, true);
            }
        });
    });

    function selectFromHash() {
        const tab = tabs.find((item) => item.hash === window.location.hash);
        if (tab) {
            selectPart(tab.dataset.rovSystemPart);
        }
    }

    configureLayout();
    selectFromHash();
    mobile.addEventListener("change", configureLayout);
    window.addEventListener("hashchange", selectFromHash);
    root.dataset.enhanced = "";
});
